import React, { useEffect, useState } from "react";


import "./Shipping.css";
import config from "../../Admin/Config.json";
import apiRequest from "../../apiCall";

const ShippingLayout = ({ children, className }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [products, setProducts] = useState([]);

  const storedData = localStorage.getItem("userData") || " {}";
  const userData = JSON.parse(storedData);
  const id = userData.id || null;

  useEffect(() => {
    resize();
  }, []);

  useEffect(() => {
    apiRequest("GET", `/shop/cartproduct/${id}`, null, false, false)
      .then((response) => {
        setProducts(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const resize = () => {
    if (document.body.offsetWidth <= 905) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  // const parseImageURL = (imageURL) => {
  //   if (imageURL) {
  //     const parsedURL = JSON.parse(imageURL);
  //     return parsedURL[0]?.image || null;
  //   }
  //   return null;
  // };

  const getTotalCartValue = () => {
    let totalValue = 0;
    products.forEach((item) => {
      totalValue += item.total_price;
    });
    return totalValue;
  };

  window.addEventListener("resize", resize);

  window.onscroll = () => {};

  return (
    <div className="shipping-layout">
      {isMobile && (
        <div className="rs">
         <main>
            {products.length > 0 ? (
              <>
                {products.map((item) => {
                  const productImage = config.awsMediaPath + item?.media[0];
                  return (
                    <>
                      <div className="product">
                        <section>
                          <img src={productImage} alt={item.name} />
                          <div>
                            <span style={{ margin: "0" }}>{item.name}</span>
                            <span style={{ marginTop: "0" }}>
                              {"Qty : " + item.Quantity}
                            </span>
                            {/* <span style={{ marginTop: "0.5rem" }}>
                              {"Chemist:" + item.chemistname}
                            </span> */}
                          </div>
                          <span className="price">
                            {"₹" + item.total_price}
                          </span>
                        </section>
                      </div>
                    </>
                  );
                })}
              </>
            ) : (
              <> </>
            )}
            {/* <div className="discount-code">
              <input
                type="text"
                placeholder="Discount code"
                spellCheck={false}
              />
              <button>Apply</button>
            </div> */}
            <div className="row" style={{ marginTop: 15 }}>
              {/* <div className="col">
                <span>Subtotal</span> <span>RS. {getTotalCartValue()}.00</span>
              </div>

              <div className="col">
                <span>Shipping</span>
                <span>Calculated at next step</span>
              </div> */}
            </div>
            <div className="row second" style={{ marginTop: 15 }}>
              <section>
                <span>Total</span>
                {/* <span>Including Rs.1,036.36 in taxes</span> */}
              </section>
              <p>RS. {getTotalCartValue()}.00</p>
            </div>
            </main>
        </div>
      )}
      <div className="ls">
        <div className={className ? className : "no-className"} id="ls">
          {children}
        </div>
      </div>
      {!isMobile && (
        <div className="rs">
          <main>
            {products.length > 0 ? (
              <>
                {products.map((item) => {
                  const productImage = config.awsMediaPath + item?.media[0];
                  return (
                    <>
                      <div className="product">
                        <section>
                          <img src={productImage} alt={item.Brand} />
                          <div>
                            <span style={{ margin: "0" }}>
                              {item.Brand} ({item.Pack} {item.UOMValue})
                            </span>
                            <p style={{ marginTop: "0.5rem" }}>
                              {"Qty : " + item.Quantity}
                            </p>
                            {/* <span style={{ marginTop: "0.5rem" }}>
                              {"Chemist:" + item.ChemistName}
                            </span> */}
                          </div>
                          <p className="price">{"₹" + item.total_price}</p>
                        </section>
                      </div>
                    </>
                  );
                })}
              </>
            ) : (
              <> </>
            )}
            {/* <div className="discount-code">
              <input
                type="text"
                placeholder="Discount code"
                spellCheck={false}
              />
              <button>Apply</button>
            </div> */}
            {/* <div className="row" style={{ marginTop: 15 }}>
              <div className="col">
                <span>Subtotal</span> <span>RS. {getTotalCartValue()}.00</span>
              </div>

              <div className="col">
                <span>Shipping</span>
                <span>Calculated at next step</span>
              </div>
            </div> */}
            <div className="row second" style={{ marginTop: 15 }}>
              <section>
                <span>Total</span>
                {/* <span>Including Rs.1,036.36 in taxes</span> */}
              </section>
              <span style={{ font: "inherit" }}>
                RS. {getTotalCartValue()}.00
              </span>
            </div>
          </main>
        </div>
      )}
    </div>
  );
};

export default ShippingLayout;
